var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25244 12.5028V1.75781V1.75781C1.25244 1.3436 1.58823 1.00781 2.00244 1.00781H8.00244V1.00781C8.41665 1.00781 8.75244 1.3436 8.75244 1.75781V12.5028V12.5028C8.75244 12.779 8.52858 13.0028 8.25244 13.0028C8.16496 13.0028 8.079 12.9799 8.00317 12.9363L5.12719 11.2824V11.2824C5.05003 11.238 4.9551 11.238 4.87794 11.2824L2.00179 12.9362V12.9362C1.76244 13.0739 1.45677 12.9915 1.31905 12.7521C1.27541 12.6763 1.25244 12.5903 1.25244 12.5028H1.25244Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.e9a34e92bcad1f30fbfe04128e19c6e1.svg";
export { ForwardRef as ReactComponent };